import { getCustomerLocation } from "sr/utils/api/company/customer/getCustomerLocation"

export const fetchCustomerLocations = async (params)=> {
    try {
   if (params?.setLoader) params?.setLoader(true)
  const queryParams = new URLSearchParams()
   if (params?.page) queryParams.append('page', params?.page)
    if (params?.limit) queryParams.append('limit', params?.limit)
   if(params?.customerId) queryParams?.append('customer_id', params?.customerId)
 if (params?.companyId) queryParams?.append('company_id', params?.companyId)
 if (params?.customerLocationId) queryParams.append('id', params?.customerLocationId)

  
 if (params?.alldata) queryParams.append('alldata', params?.alldata) 
  queryParams.append('status!','deleted')
      const res = await getCustomerLocation(queryParams)
      if(res?.success===true) {
        
      if (params?.setCustomerLocations) params?.setCustomerLocations(res?.data)
        if (params?.setLoader) params?.setLoader(false)
       if (params?.setTotalPage) params.setTotalPage(Math.ceil(res?.pagination?.total/params?.limit))
        return res?.data
      }
      else {
        if (params?.setLoader) params?.setLoader(false)
      }
    }
    catch(e:any){
      if (params?.setLoader) params?.setLoader(false)
    }
}